export enum WymagalnoscPolaSpisu {
  niewymagane,
  wymagane,
  wymaganeJezeliInnePolePuste,
  wymaganeJezeliWInnymPoluWartoscZeSlownika,
  wymaganeJezeliInnePoleNieJestPuste,
  wymaganeJezeliWInnymPoluJestWartosc,
  niewymaganeJezeliInnePoleNieJestPuste,
}

export enum WymagalnoscPolaSpisuOperator {
  brak,
  i,
  lub,
}
